/* eslint-disable func-names */
import { takeLatest, put, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as GlobalActions from "../../actions";
import * as Actions from "./store/actions";
import ActionTypes from "../../constants";
import * as Apis from "./apis";
import { wrapByLoader, wrapWithoutLoader } from "../../utils";

export default [];
